import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import axios from '../../../../library/axios';
import {
  handleJobQueuedSuccess,
  handleJobRequestError,
} from '../../../../helpers/cpanelJobFeedback';
import {
  DESCRIPTION_MAX_LENGTH,
  hasValidationErrors,
  validateEditForm,
} from './validation';

const EditCpanelTenantComp = ({ editTenant, close, fetch }) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [description, setDescription] = useState(editTenant?.description || '');
  const [errors, setErrors] = useState({});

  const handleUpdate = (event) => {
    event?.preventDefault();

    const nextErrors = validateEditForm({ description });
    setErrors(nextErrors);

    if (hasValidationErrors(nextErrors)) {
      return;
    }

    setLoading(true);
    setDisabled(true);

    axios({
      url: `/cpanel/tenants/update/${editTenant.id}`,
      method: 'PATCH',
      data: { description: description.trim() },
    })
      .then(async (res) => {
        const queued = await handleJobQueuedSuccess({
          response: res,
          actionLabel: 'Pembaruan tenant',
          close,
          fetch,
        });
        if (!queued && res.status === 200) {
          close();
          fetch();
        }
      })
      .catch((err) => {
        handleJobRequestError(err, 'Gagal memulai pembaruan tenant.');
      })
      .finally(() => {
        setLoading(false);
        setDisabled(false);
      });
  };

  return (
    <form noValidate onSubmit={handleUpdate}>
      <div className="mb-4">
        <label className="form-label">Slug</label>
        <input type="text" className="form-control" value={editTenant?.slug || ''} readOnly disabled />
      </div>

      <div className="mb-4">
        <label htmlFor="tenantDescriptionEdit" className="form-label required">
          Deskripsi
        </label>
        <textarea
          className={`form-control${errors.description ? ' is-invalid' : ''}`}
          id="tenantDescriptionEdit"
          rows={3}
          value={description}
          required
          minLength={3}
          maxLength={DESCRIPTION_MAX_LENGTH}
          onChange={(e) => {
            setDescription(e.target.value);
            if (errors.description) {
              setErrors((prev) => ({ ...prev, description: undefined }));
            }
          }}
          onBlur={() => {
            const nextErrors = validateEditForm({ description });
            if (nextErrors.description) {
              setErrors((prev) => ({ ...prev, description: nextErrors.description }));
            }
          }}
        />
        {errors.description ? (
          <div className="invalid-feedback d-block">{errors.description}</div>
        ) : null}
        <div className="form-text">Minimal 3 karakter, maksimal {DESCRIPTION_MAX_LENGTH} karakter.</div>
      </div>

      <div className="alert alert-light border mb-4 py-2 px-3 fs-7 text-muted mb-0">
        Notifikasi akan muncul saat job selesai atau gagal.
      </div>

      <div className="d-flex justify-content-start gap-2 pt-2">
        <Button type="submit" variant="primary" size="sm" disabled={disabled}>
          <IconDeviceFloppy stroke={2} className="me-1" />
          {loading ? 'Memulai job...' : 'Simpan'}
        </Button>
        <Button type="button" variant="danger" size="sm" onClick={close}>
          <IconSquareX stroke={2} className="me-1" />
          Tutup
        </Button>
      </div>
    </form>
  );
};

export default EditCpanelTenantComp;
